import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="mt-16 bg-primary-950 text-background-100">
      <div className="w-full px-4 md:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-9 h-9 rounded-md bg-accent-500 text-background-50 flex items-center justify-center">
                <i className="ri-movie-2-line text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">女友的妈妈</span>
            </div>
            <p className="text-sm leading-relaxed text-background-200 max-w-md">
              《女友的妈妈》电视剧专题站，汇集全集剧情介绍、主创演员资料与最新影视资讯，
              为追剧观众提供清晰、舒适的剧集阅读体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link to="/" className="text-background-200 hover:text-accent-300 transition-colors">首页</Link>
              </li>
              <li>
                <Link to="/episodes" className="text-background-200 hover:text-accent-300 transition-colors">剧集列表</Link>
              </li>
              <li>
                <Link to="/actors" className="text-background-200 hover:text-accent-300 transition-colors">演员介绍</Link>
              </li>
              <li>
                <Link to="/news" className="text-background-200 hover:text-accent-300 transition-colors">影视资讯</Link>
              </li>
              <li>
                <Link to="/about" className="text-background-200 hover:text-accent-300 transition-colors">关于我们</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">内容速览</h4>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link to="/episode/1" className="text-background-200 hover:text-accent-300 transition-colors">第01集 · 初次登门</Link>
              </li>
              <li>
                <Link to="/episode/8" className="text-background-200 hover:text-accent-300 transition-colors">第08集 · 雨夜</Link>
              </li>
              <li>
                <Link to="/actor/2" className="text-background-200 hover:text-accent-300 transition-colors">苏晚晴 · 饰 赵慧兰</Link>
              </li>
              <li>
                <Link to="/news/1" className="text-background-200 hover:text-accent-300 transition-colors">收官口碑走高</Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-800">
          <p className="text-xs text-background-300 leading-relaxed">
            免责声明：本站为《女友的妈妈》剧集内容演示专题，所载剧情、演员及资讯均为演示用虚构内容，
            仅供浏览与信息展示，不提供任何播放、下载服务，亦不代表任何真实影视作品或平台。
          </p>
          <p className="text-xs text-background-300 mt-3">
            © 2024 女友的妈妈 专题站 · 保留所有权利 · 本站内容仅供演示
          </p>
        </div>
      </div>
    </footer>
  );
}